import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { AppPipesModule } from '../app-pipes/app-pipes.module';
import { CommonModule } from '@angular/common';
import { CreateEditOtherTaskComponent } from '../../pages/planning/modal/create-edit-other-task/create-edit-other-task.component';
import { EditLoadTaskComponent } from '../../pages/planning/modal/edit-load-task/edit-load-task.component';

@NgModule({
  imports: [CommonModule, SharedModule, AppPipesModule],
  exports: [CreateEditOtherTaskComponent, EditLoadTaskComponent],
  declarations: [CreateEditOtherTaskComponent, EditLoadTaskComponent]
})
export class PlanningModule {}
